import React from 'react';
import { Modal, makeStyles, Theme, createStyles, Backdrop, Fade } from '@material-ui/core';

import { CreateVersionForm } from './CreateVersionForm';
import { useCancelRoute } from 'hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(2),
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
      width: '100%',
      maxWidth: 640,
      maxHeight: 'calc(100vh - 32px)',
      overflowY: 'auto',
      outline: 0,
    },
  })
);

export const CreateVersionPage = () => {
  const classes = useStyles();

  const { onCancel } = useCancelRoute('/versions');

  return (
    <Modal
      open={true}
      onClose={onCancel}
      aria-labelledby="create-version-title"
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <div className={classes.form} tabIndex={-1}>
          <CreateVersionForm onClose={onCancel} />
        </div>
      </Fade>
    </Modal>
  );
};
